import { appendALExamTemplate } from '@/functions/idp'

import RIC from './RIC_12'

export default appendALExamTemplate({
  ...RIC,
  aimName: 'A-level'
})
